import { InjectionToken } from '@angular/core';

//export const FUSE_CONFIG = new InjectionToken<any>('FUSE_APP_CONFIG');

// Create the injection token for the custom settings
//export const FUSE_CONFIG = new InjectionToken('fuseCustomConfig');
export const FUSE_CONFIG = new InjectionToken<any>('fuseCustomConfig');
